var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper",
      class: {
        "ui---lnb-collapsed": _vm.isFoldSideMenu,
        "aside-hide": _vm.isHideSideMenu,
        "s-main": _vm.isHideSideMenu,
        "ui---lnb": !_vm.isHideSideMenu
      },
      attrs: { id: "mainWrapperDiv" }
    },
    [
      _c("top-menu", {
        attrs: { fixTop: _vm.fixTop },
        on: {
          "router-reload": function($event) {
            return _vm.routerReload()
          },
          toggleFixTop: _vm.toggleFixTop
        }
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "section_container",
          on: {
            click: function($event) {
              return _vm.toggleFixTop(false)
            }
          }
        },
        [
          !_vm.isHideSideMenu
            ? _c("side-menu", {
                on: {
                  "router-reload": function($event) {
                    return _vm.routerReload()
                  },
                  "fold-event": function($event) {
                    _vm.isFoldSideMenu = !_vm.isFoldSideMenu
                  },
                  "hide-event": _vm.displaySideMenu
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isRouterAlive
            ? _c("router-view", { key: _vm.$route.fullPath })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "footer",
        {
          class: _vm.footerClass,
          on: {
            click: function($event) {
              return _vm.toggleFixTop(false)
            }
          }
        },
        [
          _c("div", { staticClass: "ui--footer-in" }, [
            _c("span", [_vm._v("© Samsung")]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: "javascript:" },
                on: {
                  click: function($event) {
                    return _vm.showTermPopup("PERSONAL_USE", $event)
                  }
                }
              },
              [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("sdl.privacyPolicy.policyTitle")))
                ])
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "confidential" }, [
              _vm._v("Confidential")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "email" }, [
              _vm._v("Contact us : "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.systemEmail) +
                    " (TEL: " +
                    _vm._s(_vm.systemTel) +
                    ")"
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66935c84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66935c84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainPage.vue
// module id = null
// module chunks = 